import { toast } from 'react-toastify';

import { Warning } from '@phosphor-icons/react';

const NotificationWarning = (message: string) => {
  toast.warning(message, {
    icon: () => <Warning size={24} color='#FF9500' />,
  });
};

export default NotificationWarning; 